// Import all SDK files as text/modules
import vendorAxios from './assets/vendor.axios.cee2297d8064255b0106.js?raw';
import vendorBrowserifySign from './assets/vendor.browserify-sign.262d500dac7fbd793b85.js?raw';
import vendorElliptic from './assets/vendor.elliptic.8350666830498dccd184.js?raw';
import vendorBrowserifyAes from './assets/vendor.browserify-aes.bc1671aedb76de95cac6.js?raw';
import vendorStreamBrowserify from './assets/vendor.stream-browserify.7ad9b49390911acdde5b.js?raw';
import vendorAsn1 from './assets/vendor.asn1.js.3483cc7f63182a3f0b82.js?raw';
import vendorHash from './assets/vendor.hash.js.9a08305c13c240a0f2eb.js?raw';
import vendorPublicEncrypt from './assets/vendor.public-encrypt.deb04f7e80668dc1211e.js?raw';
import vendorDiffieHellman from './assets/vendor.diffie-hellman.96fa799e490efa568667.js?raw';
import vendorSignalr from './assets/vendor.signalr-no-jquery.6ee4fa921ba8dc0eba79.js?raw';
import vendorMillerRabin from './assets/vendor.miller-rabin.dd407c301bc8de89c1bd.js?raw';
import vendorCreateEcdh from './assets/vendor.create-ecdh.69ce73dde28c4e953a9b.js?raw';
import vendorSjcl from './assets/vendor.sjcl.f4547262815d41f5fc42.js?raw';
import vendorMustache from './assets/vendor.mustache.0f5d8a4748abe782331b.js?raw';
import vendorMobileDeviceDetect from './assets/vendor.mobile-device-detect.8de5473c1f1106923305.js?raw';
import vendorLottieWeb from './assets/vendor.lottie-web.c63ca72f96d1c4837c16.js?raw';
import vendorBuffer from './assets/vendor.buffer.f36bb1254e482f86b62a.js?raw';
import vendorBn from './assets/vendor.bn.js.8949dfa435f84f8e13a5.js?raw';
import idscanJcs43dd7041 from './assets/idscan-jcs-43dd7041.2b3ac18c07ac038ba585.js?raw';
import idscanJcsd91a9049 from './assets/idscan-jcs-d91a9049.194314e02268c234efac.js?raw';
import idscanJcs77455583 from './assets/idscan-jcs-77455583.178cfd426c47545c4f6f.js?raw';
import idscanJcs3bb2ab8b from './assets/idscan-jcs-3bb2ab8b.05fb7793762bf9f39d33.js?raw';
import idscanJcs1ab2fc53 from './assets/idscan-jcs-1ab2fc53.d7c35cd3b5fff8a83ca1.js?raw';
import idscanJcs10de8631 from './assets/idscan-jcs-10de8631.f74a686e9a7f6e42670c.js?raw';
import idscanJcs76945664 from './assets/idscan-jcs-76945664.16afcfbbc3f1014ec443.js?raw';
import idscanJcs89419957 from './assets/idscan-jcs-89419957.ffffb2cf10c5a8b1202d.js?raw';
import idscanJcs6b882012 from './assets/idscan-jcs-6b882012.93839b50b8a7df33fef9.js?raw';
import idesMicro from './assets/ides-micro.c7f56e19625c4d2863a9.js?raw';
import idesmicroAsm from './assets/idesmicro_asm.js?raw';
import gbgStyles from './assets/styles.css?raw';

// Import static assets (SVG, JSON)
import manifest from './assets/manifest.json?raw';

// Import all SVG files
import svg0b9b632a from './assets/0b9b632a196e2eddb651.svg?raw';
import svg27091d3a from './assets/27091d3a210a8ea5c6d1.svg?raw';
import svg3cee80a9 from './assets/3cee80a9b50c29621d40.svg?raw';
import svg40809c36 from './assets/40809c361d3642a1e2ec.svg?raw';
import svg4d6c3a48 from './assets/4d6c3a480d0c9ffc2bbc.svg?raw';
import svg6b4e5455 from './assets/6b4e545576ffc830a180.svg?raw';
import svg6bc39188 from './assets/6bc391888aefac53c4f1.svg?raw';
import svg6e542ce3 from './assets/6e542ce32cd5d44e2564.svg?raw';
import svg797c950a from './assets/797c950abd06126b6fc5.svg?raw';
import svga39de283 from './assets/a39de283cf9d2bb2927b.svg?raw';
import svga7fdbf30 from './assets/a7fdbf30585e1a4f55c7.svg?raw';
import svgce862946 from './assets/ce862946cb7664646eda.svg?raw';
import svgd9e66393 from './assets/d9e66393d2753d187b04.svg?raw';
import svge7178f5b from './assets/e7178f5b283b73562187.svg?raw';
import svgfc35d6a0 from './assets/fc35d6a0ce9f9125169a.svg?raw';
import svgFile from './assets/file.svg?raw';
import svgGlobe from './assets/globe.svg?raw';
import svgNext from './assets/next.svg?raw';
import svgVercel from './assets/vercel.svg?raw';
import svgWindow from './assets/window.svg?raw';

// Map of script names to their content
export const SDK_ASSETS = {
    // JavaScript files
    'vendor.axios.cee2297d8064255b0106.js': vendorAxios,
    'vendor.browserify-sign.262d500dac7fbd793b85.js': vendorBrowserifySign,
    'vendor.elliptic.8350666830498dccd184.js': vendorElliptic,
    'vendor.browserify-aes.bc1671aedb76de95cac6.js': vendorBrowserifyAes,
    'vendor.stream-browserify.7ad9b49390911acdde5b.js': vendorStreamBrowserify,
    'vendor.asn1.js.3483cc7f63182a3f0b82.js': vendorAsn1,
    'vendor.hash.js.9a08305c13c240a0f2eb.js': vendorHash,
    'vendor.public-encrypt.deb04f7e80668dc1211e.js': vendorPublicEncrypt,
    'vendor.diffie-hellman.96fa799e490efa568667.js': vendorDiffieHellman,
    'vendor.signalr-no-jquery.6ee4fa921ba8dc0eba79.js': vendorSignalr,
    'vendor.miller-rabin.dd407c301bc8de89c1bd.js': vendorMillerRabin,
    'vendor.create-ecdh.69ce73dde28c4e953a9b.js': vendorCreateEcdh,
    'vendor.sjcl.f4547262815d41f5fc42.js': vendorSjcl,
    'vendor.mustache.0f5d8a4748abe782331b.js': vendorMustache,
    'vendor.mobile-device-detect.8de5473c1f1106923305.js': vendorMobileDeviceDetect,
    'vendor.lottie-web.c63ca72f96d1c4837c16.js': vendorLottieWeb,
    'vendor.buffer.f36bb1254e482f86b62a.js': vendorBuffer,
    'vendor.bn.js.8949dfa435f84f8e13a5.js': vendorBn,
    'idscan-jcs-43dd7041.2b3ac18c07ac038ba585.js': idscanJcs43dd7041,
    'idscan-jcs-d91a9049.194314e02268c234efac.js': idscanJcsd91a9049,
    'idscan-jcs-77455583.178cfd426c47545c4f6f.js': idscanJcs77455583,
    'idscan-jcs-3bb2ab8b.05fb7793762bf9f39d33.js': idscanJcs3bb2ab8b,
    'idscan-jcs-1ab2fc53.d7c35cd3b5fff8a83ca1.js': idscanJcs1ab2fc53,
    'idscan-jcs-10de8631.f74a686e9a7f6e42670c.js': idscanJcs10de8631,
    'idscan-jcs-76945664.16afcfbbc3f1014ec443.js': idscanJcs76945664,
    'idscan-jcs-89419957.ffffb2cf10c5a8b1202d.js': idscanJcs89419957,
    'idscan-jcs-6b882012.93839b50b8a7df33fef9.js': idscanJcs6b882012,
    'ides-micro.c7f56e19625c4d2863a9.js': idesMicro,
    'idesmicro_asm.js': idesmicroAsm,

    // CSS files
    'styles.css': gbgStyles,

    // JSON files
    'manifest.json': manifest,

    // SVG files
    '0b9b632a196e2eddb651.svg': svg0b9b632a,
    '27091d3a210a8ea5c6d1.svg': svg27091d3a,
    '3cee80a9b50c29621d40.svg': svg3cee80a9,
    '40809c361d3642a1e2ec.svg': svg40809c36,
    '4d6c3a480d0c9ffc2bbc.svg': svg4d6c3a48,
    '6b4e545576ffc830a180.svg': svg6b4e5455,
    '6bc391888aefac53c4f1.svg': svg6bc39188,
    '6e542ce32cd5d44e2564.svg': svg6e542ce3,
    '797c950abd06126b6fc5.svg': svg797c950a,
    'a39de283cf9d2bb2927b.svg': svga39de283,
    'a7fdbf30585e1a4f55c7.svg': svga7fdbf30,
    'ce862946cb7664646eda.svg': svgce862946,
    'd9e66393d2753d187b04.svg': svgd9e66393,
    'e7178f5b283b73562187.svg': svge7178f5b,
    'fc35d6a0ce9f9125169a.svg': svgfc35d6a0,
    'file.svg': svgFile,
    'globe.svg': svgGlobe,
    'next.svg': svgNext,
    'vercel.svg': svgVercel,
    'window.svg': svgWindow,
};

// Create blob URLs for each asset
const blobUrls = new Map<string, string>();

export const createBlobUrl = (filename: string): string => {
    if (blobUrls.has(filename)) {
        return blobUrls.get(filename)!;
    }

    // Handle WASM files differently - they'll be available as static files in the dist
    if (filename.endsWith('.wasm')) {
        // For WASM files, return a path that will be resolved at runtime
        const wasmUrl = `./${filename}`;
        blobUrls.set(filename, wasmUrl);
        return wasmUrl;
    }

    const content = SDK_ASSETS[filename as keyof typeof SDK_ASSETS];
    if (!content) {
        throw new Error(`SDK asset not found: ${filename}`);
    }

    let mimeType = 'application/javascript';
    if (filename.endsWith('.css')) {
        mimeType = 'text/css';
    } else if (filename.endsWith('.svg')) {
        mimeType = 'image/svg+xml';
    } else if (filename.endsWith('.json')) {
        mimeType = 'application/json';
    }

    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);

    blobUrls.set(filename, url);
    return url;
};

export const cleanupBlobUrls = () => {
    blobUrls.forEach((url) => {
        if (url.startsWith('blob:')) {
            URL.revokeObjectURL(url);
        }
    });
    blobUrls.clear();
};

// Helper function to get all available asset filenames
export const getAvailableAssets = (): string[] => {
    return [...Object.keys(SDK_ASSETS), 'idesmicro_asm.wasm'];
};